// extracted by mini-css-extract-plugin
export default {"block":"Navigation_block__RYdSG","link":"Navigation_link__V24qS","nav_link":"Navigation_nav_link__6ubeS"};